import angular from 'angular';
import SubscriptionCancelNowModal from './subscriptionCancelNowModal';
import './style.scss';

export default angular
  .module('components.subscriptionCancelNowModal', [])
  .component('subscriptionCancelNowModal', SubscriptionCancelNowModal).name;
